import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export const ExtensionBanner = () => {
  const { t } = useTranslation();
  const [isDismissed, setIsDismissed] = useState(false);
  const [detectedBrowser, setDetectedBrowser] = useState("chrome");

  useEffect(() => {
    // Detect browser
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      setDetectedBrowser("firefox");
    } else if (userAgent.includes("Edg")) {
      setDetectedBrowser("edge");
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      setDetectedBrowser("safari");
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("extensionInstalled", "true");
  };

  const handleInstallClick = () => {
    // Track installation attempt
    console.log("Extension install clicked for:", detectedBrowser);

    // Open appropriate store
    const storeUrls = {
      chrome:
        "https://chromewebstore.google.com/detail/onbookmarks/mkegjpfabinfdfgiemmfhpfmfeokdbpo",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/onbookmarks/",
      edge: "https://microsoftedge.microsoft.com/addons/detail/onbookmarks/gccckckcmaolhemnamcaigcbmaebnodc",
      //safari: "https://apps.apple.com/app/onbookmarks/[app-id]",
    };

    window.open(storeUrls[detectedBrowser], "_blank");
  };

  if (isDismissed) return null;

  const browserInfo = {
    chrome: {
      name: "Chrome",
      icon: "bi-browser-chrome",
      color: "#4285F4",
    },
    firefox: {
      name: "Firefox",
      icon: "bi-browser-firefox",
      color: "#FF7139",
    },
    edge: {
      name: "Edge",
      icon: "bi-browser-edge",
      color: "#0078D4",
    },
    /*
    safari: {
      name: "Safari",
      icon: "bi-browser-safari",
      color: "#000000",
    },
    */
  };

  const browser = browserInfo[detectedBrowser] || browserInfo.chrome;

  return (
    <div className="p-3 mt-auto">
      <div className="bg-purple bg-gradient position-relative overflow-hidden rounded-4 shadow-sm">
        {/* Close button */}
        <button
          onClick={handleDismiss}
          className="btn btn-none btn-sm position-absolute top-0 end-0 p-0 me-2 text-white-50 cursor-pointer z-1"
          onMouseEnter={(e) => (e.target.style.color = "#fff")}
          onMouseLeave={(e) =>
            (e.target.style.color = "rgba(255, 255, 255, 0.5)")
          }
          aria-label={t("components.extensionBanner.dismissAriaLabel")}
        >
          <i className="bi bi-x fs-2"></i>
        </button>

        {/* Content */}
        <div className="p-4 position-relative">
          {/* Header with icon */}
          <div className="d-flex align-items-center mb-3">
            <div className="extension-icon-wrapper me-2 icon bg-light bg-opacity-25">
              <i className={`bi ${browser.icon} fs-4 text-white`}></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-0 text-white fw-semibold">{t("components.extensionBanner.title")}</h6>
              <small className="text-white">{t("components.extensionBanner.subtitle")}</small>
            </div>
          </div>

          {/* Features list */}
          <div className="mb-3">
            <div className="d-flex align-items-center text-white small mb-1">
              <i className="bi bi-lightning-charge-fill me-2 text-yellow"></i>
              <span>{t("components.extensionBanner.features.oneClick")}</span>
            </div>
            <div className="d-flex align-items-center text-white small mb-1">
              <i className="bi bi-robot me-2 text-white"></i>
              <span>{t("components.extensionBanner.features.aiPowered")}</span>
            </div>
            <div className="d-flex align-items-center text-white small">
              <i
                className="bi bi-shield-lock-fill me-2"
                style={{ color: "#34d399" }}
              ></i>
              <span>{t("components.extensionBanner.features.encrypted")}</span>
            </div>
          </div>

          {/* CTA Button */}
          <button
            onClick={handleInstallClick}
            className="btn btn-primary w-100 d-flex align-items-center justify-content-center h-min-auto"
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = `0 6px 20px ${browser.color}50`;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = `0 4px 16px ${browser.color}40`;
            }}
          >
            <i className="bi bi-download me-2"></i>
            {t("components.extensionBanner.installButton", { browser: browser.name })}
          </button>
        </div>
      </div>
    </div>
  );
};
